import React from 'react';
interface SectionLabelProps {
  number?: string;
  title: string;
  className?: string;
}
export function SectionLabel({
  number,
  title,
  className = ''
}: SectionLabelProps) {
  return <div className={`font-mono text-xs uppercase tracking-widest text-ink/60 mb-8 ${className}`} data-id="element-61" data-mp="2yfcjkivgpoyy">
      {number && <span data-id="element-62" data-mp="33eyxkuj4798t">{number}&nbsp;&nbsp;·&nbsp;&nbsp;</span>}
      <span data-id="element-63" data-mp="33bjd1c6o9800">{title}</span>
    </div>;
}